// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__BTKyK","tabs_item":"style_tabs_item__qc4pS","dropdown":"style_dropdown__o70Dx"};